"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.infiniteScrollCollapsableTable = void 0;
var _testUtils = require("react-intersection-observer/test-utils");
var resetScroll = function resetScroll() {
  (0, _testUtils.mockAllIsIntersecting)(false);
};
var scrollEndReached = function scrollEndReached() {
  (0, _testUtils.mockAllIsIntersecting)(true);
};
var infiniteScrollCollapsableTable = {
  resetScroll: resetScroll,
  scrollEndReached: scrollEndReached
};
exports.infiniteScrollCollapsableTable = infiniteScrollCollapsableTable;